import React from 'react';
import { 
  HelpCircle, 
  Calendar, 
  Briefcase, 
  CalendarClock, 
  Plus, 
  User,
  Clock,
  FileText,
  CalendarCheck
} from 'lucide-react';

/**
 * Компонент с советами по использованию калькулятора дат
 */
const TipsSidebar = () => {
  const tips = [
    {
      icon: Calendar,
      title: 'Включение конечной даты',
      description: 'Если включить конечную дату в расчет, она будет учитываться как полный день в результате.'
    },
    {
      icon: Briefcase,
      title: 'Расчет рабочих дней',
      description: 'Рабочими считаются дни с понедельника по пятницу, за исключением праздников.'
    },
    {
      icon: CalendarClock,
      title: 'Российские праздники',
      description: 'В расчете учитываются все федеральные праздники РФ и переносы выходных дней.'
    },
    {
      icon: Plus,
      title: 'Добавление периода',
      description: 'При добавлении рабочих дней выходные и праздники автоматически пропускаются.'
    },
    {
      icon: User,
      title: 'Расчет возраста',
      description: 'Для точного расчета возраста указывайте дату рождения в формате YYYY-MM-DD.'
    },
    {
      icon: Clock,
      title: 'Кварталы и полугодия',
      description: 'Для расчета квартала используйте 3 месяца, для полугодия - 6 месяцев.'
    },
    {
      icon: FileText,
      title: 'Сохранение результатов',
      description: 'Используйте кнопку "Сохранить расчет" чтобы вернуться к нему позже.'
    }
  ];

  return (
    <div className="bg-white dark:bg-gray-800 rounded-xl border border-gray-200 dark:border-gray-700 p-5 shadow-sm">
      <h3 className="text-lg font-medium text-gray-900 dark:text-white mb-4 flex items-center">
        <HelpCircle className="w-5 h-5 mr-2 text-cyan-500" />
        Советы по использованию
      </h3>

      <div className="space-y-3">
        {tips.map((tip, index) => (
          <div 
            key={index} 
            className="flex items-start space-x-3 p-3 bg-gray-50 dark:bg-gray-700/30 rounded-lg border border-gray-200 dark:border-gray-700 hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors"
          >
            <tip.icon className="w-5 h-5 text-cyan-500 mt-0.5 flex-shrink-0" />
            <div>
              <h4 className="text-sm font-medium text-gray-900 dark:text-white mb-1">
                {tip.title}
              </h4>
              <p className="text-xs text-gray-600 dark:text-gray-400">
                {tip.description}
              </p>
            </div>
          </div>
        ))}
      </div>

      <div className="mt-6 p-4 bg-cyan-50 dark:bg-cyan-900/20 border border-cyan-100 dark:border-cyan-800 rounded-lg">
        <div className="flex items-start space-x-3">
          <CalendarCheck className="w-5 h-5 text-cyan-500 mt-0.5 flex-shrink-0" />
          <div>
            <h4 className="text-sm font-semibold text-cyan-700 dark:text-cyan-300 mb-2">
              Производственный календарь
            </h4>
            <p className="text-xs text-cyan-600 dark:text-cyan-400 mb-3">
              Для точного планирования используйте производственный календарь России с учетом переносов праздничных дней.
            </p>
            <button className="w-full py-1.5 text-xs bg-cyan-500 text-white rounded hover:bg-cyan-600 transition-colors">
              Открыть календарь на {new Date().getFullYear()} год
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TipsSidebar;